export const SettingsValidation = {
  GRADE_LEVEL: 'Please select at least one grade level',
  SUBJECT_AREA: 'Please select at least one subject area',
  TASK_TYPE: 'Please select at least one task type',
  KEYWORDS: 'Please enter at least one keyword',
};
